// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomePage.vue'

const AegisPage = () => import('../views/AegisPage.vue')
const EcosystemPage = () => import('../views/EcosystemPage.vue')
const ProductsPage = () => import('../views/ProductsPage.vue')
const ProductDetailPage = () => import('../views/ProductDetailPage.vue')
const ModulesPage = () => import('../views/ModulesPage.vue')
const AcademyPage = () => import('../views/AcademyPage.vue')
const FaqPage = () => import('../views/FaqPage.vue')
const PaperSection = () => import('../views/PaperSection.vue')
const Contacts = () => import('../views/ContactsPage.vue')

function redirectWithQuery(path) {
  return (to) => ({ path, query: to.query, hash: to.hash })
}

function paperRedirect(to) {
  const paperId = String(to.params.paperId || '').trim()
  const variant = String(to.params.variant || '').trim()
  const path = paperId
    ? `/academy/papers/${encodeURIComponent(paperId)}${variant ? `/${encodeURIComponent(variant)}` : ''}`
    : '/academy/papers'

  return { path, query: to.query, hash: to.hash }
}

const routes = [
  { path: '/', name: 'HomePage', component: Home },
  { path: '/ecosystem', name: 'EcosystemPage', component: EcosystemPage },
  { path: '/ecosystem/products', name: 'ProductsPage', component: ProductsPage },
  {
    path: '/ecosystem/products/prometeo',
    name: 'ProductPrometeo',
    component: ProductDetailPage,
    meta: { productId: 'prometeo' }
  },
  {
    path: '/ecosystem/products/nemo',
    name: 'ProductNemo',
    component: ProductDetailPage,
    meta: { productId: 'nemo' }
  },
  {
    path: '/ecosystem/products/backsense',
    name: 'ProductBackSense',
    component: ProductDetailPage,
    meta: { productId: 'backsense' }
  },
  {
    path: '/ecosystem/products/backsense/aura',
    name: 'ProductAura',
    component: ProductDetailPage,
    meta: { productId: 'aura' }
  },
  { path: '/ecosystem/modules', name: 'ModulesPage', component: ModulesPage },
  { path: '/ecosystem/use-cases', redirect: redirectWithQuery('/ecosystem/modules') },
  { path: '/aegis', name: 'AegisPage', component: AegisPage },
  { path: '/academy', name: 'AcademyPage', component: AcademyPage },
  { path: '/academy/papers', name: 'PaperSection', component: PaperSection },
  { path: '/academy/papers/:paperId/:variant?', name: 'AcademyPaperDetail', component: PaperSection },
  { path: '/academy/faq', name: 'FaqPage', component: FaqPage },
  { path: '/contact', name: 'ContactsPage', component: Contacts },
  { path: '/moduli', redirect: redirectWithQuery('/ecosystem/modules') },
  { path: '/tutorial', redirect: redirectWithQuery('/ecosystem/modules') },
  { path: '/percorsi', redirect: redirectWithQuery('/ecosystem/modules') },
  { path: '/paper', redirect: paperRedirect },
  { path: '/paper/:paperId/:variant?', redirect: paperRedirect },
  { path: '/contacts', redirect: redirectWithQuery('/contact') }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ el: to.hash, top: 110, behavior: 'smooth' })
        }, 320)
      })
    }
    return { left: 0, top: 0 }
  }
})

export default router
